import {
  Box,
  Container,
  Stack,
  Typography,
  Button,
  Paper,
  InputBase,
  Divider,
  CircularProgress, // ✅ added
} from "@mui/material";
import React, { useState } from "react";
import "./index.css";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LocationOn from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { Link } from "react-router-dom";

function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false); // ✅ added

  const handleSubmit = async (e) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    e.preventDefault();

    if (!email || email.trim() === "") {
      alert("Please enter a valid email address");
      return;
    } else if (!emailRegex.test(email)) {
      alert("Invalid email address");
      return;
    }

    setLoading(true); 

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbyWFT0kYLOsXCM5cUBCOjEMR7fto1MqZvIsRmlOJPZIX_kcdUWagh6ffrg6pAmCOBs/exec";

    const formData = new FormData();
    formData.append("Email", email);

    try {
      const response = await fetch(scriptURL, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      console.log("Response:", result);

      if (response.ok) {
        alert("Subscribed successfully!");
        setEmail("");
      } else {
        throw new Error(result.error || "Unknown error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert(`Subscription failed: ${error.message}`);
    } finally {
      setLoading(false); // ✅ stop loader
    }
  };

  return (
    <Box sx={{ pt: 8 }} className="footer-bg">
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 4, md: 8 }}
          justifyContent="space-between"
          alignItems="flex-start"
        >
          {/* Contact Section */}
          <Box sx={{ width: { xs: "100%", md: "25%" } }}>
            <Typography gutterBottom className="footer-title">
              GET IN TOUCH
            </Typography>
            <Stack spacing={1}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <LocalPhoneIcon className="footer-icon" />
                <Typography component="span">+61 449 609 681</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <EmailIcon className="footer-icon" />
                <Typography component="span">
                  info@aspiretaxbook.com.au
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <LocationOn className="footer-icon" />
                <Typography component="span">
                  <a
                    className="no-style"
                    href="https://www.google.com/maps/place/12+Klandy+Dr,+Kalkallo+VIC+3064,+Australia/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    12 Klandy Drive Kalkallo, VIC, 3064, Australia
                  </a>
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "20px !important",
                }}
              >
                <FacebookIcon className="footer-icon" />
                <InstagramIcon className="footer-icon" />
                <XIcon className="footer-icon" />
                <LinkedInIcon className="footer-icon" />
              </Box>
            </Stack>
            <Box sx={{ display: "flex", alignItems: "center", marginTop:'20px' }}>
              <Typography component="span" style={{ fontWeight:'bold', marginRight:'10px' }}>
                ABN
              </Typography>
              <Typography component="span">
                45 692 343 445
              </Typography>
            </Box>

          </Box>

          {/* Navigation Section */}
          <Box sx={{ width: { xs: "100%", md: "20%" } }}>
            <Typography className="footer-title" gutterBottom>
              NAVIGATE
            </Typography>
            <Stack spacing={1}>
              <Link to="/about-us" style={{ textDecoration: "none" }}>
                <Typography className="footer-description" component="span">
                  About Us
                </Typography>
              </Link>
              <Link to="/contact-us" style={{ textDecoration: "none" }}>
                <Typography className="footer-description" component="span">
                  Contact Us
                </Typography>
              </Link>
              <Link to="/services" style={{ textDecoration: "none" }}>
                <Typography className="footer-description" component="span">
                  Services
                </Typography>
              </Link>
            </Stack>
          </Box>

          {/* Newsletter Section */}
          <Box sx={{ width: { xs: "100%", md: "35%" } }}>
            <Typography className="footer-title" gutterBottom>
              NEWSLETTER
            </Typography>
            <Typography className="footer-description" gutterBottom>
              Subscribe to our newsletter in order to get latest updates
            </Typography>

            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
              <Paper
                component="form"
                onSubmit={handleSubmit}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  maxWidth: 500,
                  borderRadius: 1,
                  overflow: "hidden",
                }}
              >
                <InputBase
                  sx={{
                    flex: 1,
                    px: 2,
                  }}
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />

                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading}
                  sx={{
                    boxShadow: "none",
                    px: 3,
                    backgroundColor: "#23A215",
                    borderRadius: 0,
                    height: "100%",
                  }}
                >
                  {loading ? (
                    <CircularProgress size={20} sx={{ color: "#fff" }} />
                  ) : (
                    <SendRoundedIcon />
                  )}
                </Button>
              </Paper>
            </Stack>
            <Stack direction="row" spacing={5} sx={{ mt: 2, justifyContent:'end' }}>
              <Box
              component="img"
              src="/assets/Tax-Agent.png"
              alt="Company Logo"
              sx={{ width: 70 }}
              >
              </Box>
              <Box
              component="img"
              src="/assets/xero-logo.png"
              alt="Company Logo"
              sx={{ width: 150 }}
              >
              </Box>
            </Stack>
          </Box>
        </Stack>
      </Container>

      <Divider sx={{ mt: 2, backgroundColor: "grey.500" }} />
      <Container maxWidth="xl">
        <Box
          sx={{
            display: { xs: "grid", sm: "flex" },
            alignItems: "center",
            justifyContent: "space-between",
            py: 4,
          }}
        >
          <Typography variant="body2">
            © 2025 Smart Solutions. All rights reserved.
          </Typography>

          <Box
            component="img"
            src="/assets/aspire logo-white.png"
            alt="Company Logo"
            sx={{ width: 200 }}
          />
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;